import sniffer from 'snifferjs'
import Menu from './menu.js'
import {initPopups} from './popups.js'
import {initParallax} from './parallx.js'
import enableInlineVideo from 'iphone-inline-video'

const devMode = true;
const $body = $('body');
const $app = $('.app');
const $footer = $('.s-footer');
const $intro = $('.app > .intro');
let showIntro = true;
let nextLink;
let nextMenuItemLink;
let wW = $(window).width();
var sniff = sniffer(navigator.userAgent);

class App {

  constructor(opt = {}) {


  console.log("%cCreated by wokine","color: #000; padding: 5px 0px;"),console.log("%chttp://wokine.com","color:#ccc")

	if ($('.main-nav').length > 0) {
		const menu = new Menu();
	}

  var iframed = document.location.search.substring(1).split('=')[1];
  if(iframed) $('body').addClass('iframed');


    this.init();
    this.addEvents();
    this.intro();
    //Verif contact_form

  }

  init() {

    $(window).scrollTop(0);
    FastClick.attach(document.body);

    //removeLoading
    $body.removeClass('is-loading');

    //marginFooter
    $('#barba-wrapper').css({marginBottom:$footer.outerHeight()})

    //init Barba
    Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, container) {

      $body.removeClass('page-'+prevStatus.namespace);
      $body.addClass('page-'+currentStatus.namespace);

      if ( $("#contact_form").length){
            $('#contact_form').parsley();

            $("#contact_form").submit(function (e) {
                e.preventDefault();
                $('body').css( 'cursor', 'wait');
                $("#submitFormContact:hover").css( 'cursor', 'wait');
                $("#submitFormContact").attr("disabled", true);

                var _this = $(this);

                _this.parsley().reset();
                $(".error-form, .success-form").hide()


                if (_this.parsley().isValid()){
                    $.ajax({
                        url: _this.data("ajaxurl"),
                        method: "POST",
                        data: _this.serialize(),
                        success : function (data) {
                          $('body').css( 'cursor', 'default');
                          $("#submitFormContact").removeAttr('style');
                          $("#submitFormContact").attr("disabled", false);

                            $(".error-form").show().text(data+"");
                            _this[0].reset()
                        },
                        error : function (resp) {
                          $('body').css( 'cursor', 'default');
                          $("#submitFormContact").removeAttr('style');
                          $("#submitFormContact").attr("disabled", false);

                            var error_json = JSON.parse(resp.responseText);

                            if (error_json.field != ""){
                                window.ParsleyUI.addError($("[name="+error_json.field+"]").parsley(), "myCustomError", error_json.message);
                            } else {
                                $(".error-form").show().text(error_json.message);
                            }
                            //ok
                        }
                    })
                }
            })
        }

      initPopups();

      if (!showIntro) {
        setTimeout(() => {
          initParallax(container);
        }, 300);
      }

      //SetCurrentLink
      let currentPage = currentStatus.namespace;
      $('.main-nav .'+currentPage).addClass('active');
      TweenMax.to($('.s-header > .main-nav .'+currentPage).find('svg path'), 0.8, {drawSVG:"100%", ease:Power3.easeInOut}, 0)
      TweenMax.staggerTo($('.s-header > .main-nav .'+currentPage).find('.txt > div > div'), 0.6, {y:0,  ease:Power3.easeOut}, 0.02, 0)

      //updateNextLink
      nextMenuItemLink = $('.main-nav .active').next().find('a').attr('href');
      let $nextbtn = $(container).find('.btn-next');
      if (nextMenuItemLink) {

        $nextbtn.attr('href', nextMenuItemLink);
        $nextbtn.on('click', (e) => {
          TweenMax.to($('.s-header > .main-nav .active').find('svg path'), 0.4, {drawSVG:"0%", ease:Power3.easeInOut}, 0)
          TweenMax.staggerTo($('.s-header > .main-nav .active').find('.txt > div > div'), 0.4, {y:30,  ease:Power3.easeOut}, 0.01, 0)
          $('.main-nav .active').removeClass('active');
        });
      }


    });

    Barba.Pjax.getTransition = function() {
      return pagesTransition;
    };

    Barba.Pjax.start();

  }

  addEvents() {

    window.onbeforeunload = function() {window.scrollTo(0,0);}
    $(window).on('resize', (e)=> {

      wW = $(window).width();
      $('#barba-wrapper').css({marginBottom:$footer.outerHeight()})

    });

  }

  intro() {

    $body.removeClass('is-loading');

    if($body.hasClass('page-ligne-dassemblage')) {
      TweenMax.set('.intro', {zIndex:25});
    }

    const tlIntroIn = new TimelineMax({ paused: true });
    let introSplitText = new SplitText( $intro.find('p'), {type:"words,chars"});
    let introChars = introSplitText.words;
    let menuSplitLink = new SplitText( $intro.find('.nav-main-link'), {type:"words, chars"});
    TweenMax.set($intro.find('.nav-main-link > div > div'), {y:30});
    tlIntroIn.set($intro.find('.zoom-line'), {autoAlpha:0});
    tlIntroIn.set($intro.find('.zoom-line .line'), {width:0, height:0});
    tlIntroIn.set($intro.find('.zoom-line svg path'), {drawSVG:"0%"});
    tlIntroIn.staggerFrom(introChars, 1, {opacity:0, x:40,  ease:Power3.easeOut}, 0.05, 1)
    tlIntroIn.from($intro.find('p'), 3, {x:140,  ease:Power3.easeOut}, 1)
    tlIntroIn.staggerTo(introChars, 1, {opacity:0, x:-40,  ease:Power3.easeIn}, 0.05, 4)
    tlIntroIn.to($intro.find('p'), 3, {x:-140,  ease:Power3.easeIn}, 4)
    tlIntroIn.add((e)=>{

        if(!$body.hasClass('page-ligne-dassemblage') || sniff.features.mobile ) {
          showIntro=false;
          tlIntroIn.pause();
          $('body').removeClass('showIntro');
          initParallax($('.barba-container'));
          TweenMax.set("header.s-header .brand", {y:0, autoAlpha:1});
          TweenMax.set("header.s-header .menu-trigger", {y:0, autoAlpha:1});
          tlIntroOut.restart();
        }

    }, 4)
    tlIntroIn.from($intro.find('#introVideo'), 3, {x:"200%", y:"-80%", scale:1.6, skewY:5, skewX:5,  ease:Power3.easeOut}, 5)
    tlIntroIn.staggerFrom(".intro .lines .line", 1.4, {scaleY:0,  ease:Power3.easeInOut}, 0.1, 5)
    tlIntroIn.staggerTo($intro.find('.zoom-line'), 1, {autoAlpha:1, ease:Power3.easeInOut}, 0.3, 7)
    tlIntroIn.staggerTo($intro.find('.nav-main-link > div > div'), 0.6, {y:0,  ease:Power3.easeOut, overwrite:"all"}, 0.015, 7)
    tlIntroIn.staggerTo($intro.find('.zoom-line svg path'), 1, {drawSVG:"100%", ease:Power3.easeInOut}, 0.3, 7)
    tlIntroIn.staggerTo($intro.find('.zoom-line .line'), 1, {width:"100%", height:"100%", ease:Power3.easeInOut}, 0.3, 7)
    tlIntroIn.from($intro.find('.scroll-more-container'), 2, {y:"100%",  ease:Power3.easeOut}, 7)
    tlIntroIn.from($intro.find('.scroll-more-container .scroll-more'), 2, {y:-100, autoAlpha:0,  ease:Power3.easeOut}, 7.4)
    tlIntroIn.from($intro.find('.scroll-more-container .scroll-more__txt'), 2, {autoAlpha:0,  ease:Power3.easeOut}, 7.6)
    tlIntroIn.from("header.s-header .brand", 1.4, {y:-40, autoAlpha:0,  ease:Power3.easeOut}, 7.5)
    tlIntroIn.from("header.s-header .menu-trigger", 1.4, {y:-40, autoAlpha:0,  ease:Power3.easeOut}, 7.8)
    tlIntroIn.restart();


    const tlIntroOut = new TimelineMax({ paused: true });
    tlIntroOut.to($intro, 1.6, {y:"-100%",  ease:Power3.easeInOut}, 0)
    tlIntroOut.to($intro.find('.video-container'), 2, {y:"40%", ease:Power3.easeInOut}, 0)
    tlIntroOut.to($intro.find('.scroll-more-container'), 2, {y:"150%",  ease:Power3.easeOut}, 0)
    tlIntroOut.staggerFrom("#barba-wrapper .lines .line", 1.2, {scaleY:0,  ease:Power3.easeOut}, 0.04, 0.5)
    tlIntroOut.from(".barba-container", 2.4, {y:"20%",  ease:Power3.easeInOut}, 0)


    $intro.find('.scroll-more, .nav-main-link').on('click', (e) => {

      if ($(e.currentTarget).parent().hasClass('manipulation') || $(e.currentTarget).hasClass('scroll-more')) {

        e.preventDefault();
        $('.main-nav .manipulation').addClass('active');
		    TweenMax.to($('.s-header > .main-nav .manipulation').find('svg path'), 0.8, {drawSVG:"100%", ease:Power3.easeInOut}, 0)
        TweenMax.staggerTo($('.s-header > .main-nav .manipulation').find('.txt > div > div'), 0.6, {y:0,  ease:Power3.easeOut}, 0.02, 0)

      } else {

        TweenMax.to($('.s-header > .main-nav .active').find('svg path'), 0.4, {drawSVG:"0%", ease:Power3.easeInOut}, 0)
        TweenMax.staggerTo($('.s-header > .main-nav .active').find('.txt > div > div'), 0.4, {y:30,  ease:Power3.easeOut}, 0.01, 0)
        $('.main-nav .active').removeClass('active');

      }

      showIntro = false;
      $('body').removeClass('showIntro');
      initParallax($('.barba-container'));
      tlIntroOut.restart();

      //updateNextLink
      nextMenuItemLink = $('.main-nav .active').next().find('a').attr('href');
      let $nextbtn = $('.barba-container').find('.btn-next');
      if (nextMenuItemLink) {

        $nextbtn.attr('href', nextMenuItemLink);
        $nextbtn.on('click', (e) => {
          TweenMax.to($('.s-header > .main-nav .active').find('svg path'), 0.4, {drawSVG:"0%", ease:Power3.easeInOut}, 0)
          TweenMax.staggerTo($('.s-header > .main-nav .active').find('.txt > div > div'), 0.4, {y:30,  ease:Power3.easeOut}, 0.01, 0)
          $('.main-nav .active').removeClass('active');
        });

      }

    })

    $('.menu-trigger .contact').on('click', (e) => {

      if (showIntro) {
        showIntro = false;
        $('body').removeClass('showIntro');
        initParallax($('.barba-container'));
        tlIntroOut.restart();
      }

    });

    $('.intro').mousemove(function(e){

    	let xMouse = e.pageX - $(this).offset().left - ($(this).width()/2)
    	let yMouse = e.pageY - $(this).offset().top - ($(this).height()/2)

      $('*[data-mouse-parallax]').each(function(){

        var factor = parseFloat($(this).data('mouse-parallax'));
    		let xFinal = xMouse * factor;
        let yFinal = yMouse * factor;
        TweenMax.to($(this), 1.2, {x:xFinal, y:yFinal});

      });

    })

  }

}

var pagesTransition = Barba.BaseTransition.extend({
  start: function() {

    Promise
      .all([this.newContainerLoading, this.transitionOut()])
      .then(this.transitionIn.bind(this));

  },

  transitionOut: function() {

    var deferred = Barba.Utils.deferred();
    var oldContainer = $(this.oldContainer).find('> .container');

    TweenMax.to(window, 0.8, {scrollTo:0, ease: Power3.easeIn,});
    TweenMax.to(oldContainer, 0.8, {
      y: -250,
      opacity: 0,
      ease: Power3.easeIn,
      onComplete: function() {
        deferred.resolve();
      }
    });

    return deferred.promise;

  },

  transitionIn: function() {

    var _this = this;
    var $el = $(this.newContainer);
    let alpha;

    $(window).scrollTop(0);
    $(this.oldContainer).hide();

    TweenMax.set($el, {
      visibility: 'visible',
      opacity:0,
      y: 250
    });

    TweenMax.to($el, 1.8, {
      y: 0,
      opacity: 1,
      ease: Power3.easeOut,
      delay:1,
      onComplete: function() {
        _this.done();
      }
    });
  }
});

const app = new App();
